import React, { Fragment, ReactNode } from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

import AbbreviateNumber from "components/formatting/AbbreviateNumber";
import ISODateTime from "components/formatting/ISODateTime";
import { getUsageCategoryList, UsageCategoryKey, UsageInterval, UsageIntervalKey, UsageMetric } from "routes/apiUsage/types/Usage";

const UsageCategoryList = getUsageCategoryList();

interface UsageIntervalTooltipProps {
  activeUsageCategories: Array<UsageCategoryKey>;
  activeUsageMetric: UsageMetric;
  usageInterval: UsageInterval;
}

export default function UsageIntervalTooltip(props: UsageIntervalTooltipProps): React.JSX.Element {
  const { i18n } = useTranslation();
  const theme = useTheme();

  let rows: Array<ReactNode> = [];
  for (const key of props.activeUsageCategories) {
    const valueKey = `${key}_${props.activeUsageMetric}` as UsageIntervalKey;
    if (valueKey === "date") {
      continue;
    }
    const value = props.usageInterval[valueKey] || 0;
    const colorIndex = UsageCategoryList.indexOf(key as UsageCategoryKey);
    rows.push((
      <Fragment key={key}>
        <Typography color={theme.colors.namedColors.chartColorArray[colorIndex]} sx={{whiteSpace: "nowrap"}}>{i18n.t(`usage.categories.${key}`)}</Typography>
        <AbbreviateNumber hideTooltip={true} sx={{justifySelf: "end"}} value={value} />
      </Fragment>
    ));
  }

  return (
    <Box>
      <ISODateTime hideTime isoString={props.usageInterval.date} sx={{fontWeight: "bold"}} useUTC={true} />
      <Box
        sx={{
          display: "grid",
          columnGap: 1,
          gridTemplateColumns: "1fr min-content"
        }}>
        {rows}
      </Box>
    </Box>
  );
}